NotificationFactory.$inject = ['_', '$q', 'toastr', 'moment'];

/* @ngInject */
function NotificationFactory(_, $q, toastr, moment) {

    var DesktopNotification = window.Notification;
    if (DesktopNotification) {
        DesktopNotification.ask = function () {
            if (DesktopNotification.permission !== 'denied') {
                return DesktopNotification.requestPermission();
            }
            var promise = $q.defer();
            promise.reject();
            return promise;
        };
    }

    /**
     * [Notification description]
     * @class Notification
     * @constructor
     * @param  {Object} data
     */
    function Notification(data) {
        this.id = data.id;
        this.action = data.action;
        this.data = _.assign({
            // Self fix
            by_club: false
        }, data);

        this.isToast = false;
        this.isDesktop = false;
        this.created_at = this.data.created_at ? moment(this.data.created_at) : moment();

        _.assign(this,
            _messages[_messages.hasOwnProperty(data.action) ?
                data.action : 'default']);
    }

    /**
     * Gets the User ID (if the actor is an user)
     * @method uid
     * @return {Number | false}
     */
    Notification.prototype.uid = function () {
        var user = this.data.actor;
        if (user.online) {
            return false;
        }
        return user.id;
    };

    /**
     * @method getCreationDate
     * @return {MomentDate}
     */
    Notification.prototype.getCreationDate = function () {
        return this.created_at;
    };

    /**
     * @method getTitle
     * @return {String}
     */
    Notification.prototype.getTitle = function () {
        return this.title;
    };

    /**
     * @method getMessage
     * @return {String}
     */
    Notification.prototype.getMessage = function () {
        return this.message_simple(this.data);
    };
    /**
     * @method getMessageFull
     * @return {String}
     */
    Notification.prototype.getMessageFull = function () {
        if (this.message_full) {
            return this.message_full(this.data);
        } else {
            return this.message_simple(this.data);
        }
    };


    /**
     * Triggers a desktop notification
     * @method desktop
     */
    Notification.prototype.desktop = function () {
        if (!DesktopNotification) return;
        DesktopNotification.ask().then(this._desktopNotify.bind(this));
    };
    /**
     * @method _desktopNotify
     * @private
     */
    Notification.prototype._desktopNotify = function () {
        if (!DesktopNotification) return;
        var notification = new DesktopNotification(this.getTitle(), {
            body: this.getMessage(),
            vibrate: true,
            tag: this.data.action + '-' + this.data.booking.id,
            icon: '/assets/img/ISOLOGO.svg',
            badge: '/assets/img/ISOLOGO.svg',
        });
        setTimeout(notification.close.bind(notification), 5000);
    };

    /**
     * Triggers a toastr notification
     * @method toastr
     * @param  {Object} options Optional toastr lib options
     * @return {Toastr}
     */
    Notification.prototype.toastr = function (options) {
        return toastr[this.type](this.getMessage(), this.getTitle(), options);
    };

    /**
     * @method toJSON
     * @return {JSON}
     */
    Notification.prototype.toJSON = function () {
        return {
            type: this.type,
            title: this.title,
            message: this.getMessageFull(),
            created_at: this.created_at
        };
    };

    var Factory = {
        init: function () {
            if (!DesktopNotification) return;
            DesktopNotification.ask();
        },
        create: function (payload) {
            return new Notification(payload);
        },
        collect: function (array) {
            return _.map(array, function (noti) {
                var data = noti.data;
                data.created_at = noti.created_at;

                return Factory.create(data);
            });
        }
    };

    /**
     * For class inheritance, the specific class messages
     * @type {Object}
     */
    var _messages = {
        'new_local': {
            title: 'Reserva local creada',
            type: 'info',
            message_simple: ({actor, date, court}) => `${actor.name} creó una reserva el ${moment(date).format('dddd, DD [de] MMM, HH:mm')}hs en ${court.name}`,
            message_full: ({actor, date, court, booking}) => `<b>${ actor.name }</b> creó ${ booking.fixed ? 'un turno fijo' : 'una reserva' } el ${ moment(date).format('dddd, DD [de] MMM, HH:mm') }hs en ${ court.name }`,
            isToast: true,
        },
        'cancel_local': {
            title: 'Reserva local cancelada',
            type: 'warning',
            message_simple: ({actor, date, court}) => `${ actor.name } canceló la reserva del ${ moment(date).format('dddd, DD [de] MMM, HH:mm') }hs en ${ court.name }`,
            isToast: true,
        },
        'new_online': {
            title: 'Nueva reserva online',
            type: 'success',
            message_simple: ({actor, date, court}) => `El jugador ${ actor.name } creó una reserva online para el ${ moment(date).format('dddd, DD [de] MMM, HH:mm') }hs en ${ court.name }`,
            message_full: ({actor, date, court}) => `El jugador ${ actor.name } creó una reserva online para el ${ moment(date).format('dddd, DD [de] MMM, HH:mm') }hs en la cancha ${ court.name }`,
            isToast: true,
            isDesktop: true
        },
        'cancel_online': {
            title: 'Reserva online cancelada',
            type: 'error',
            message_simple: ({actor, date, court, by_club}) => `${ by_club ? 'El club canceló la reserva de ' + actor.name : 'El jugador ' + actor.name + ' canceló la reserva' } para el ${ moment(date).format('dddd, DD [de] MMM, HH:mm') }hs en ${ court.name }`,
            message_full: ({actor, date, court, by_club}) => `${ by_club ? 'El club canceló la reserva de ' + actor.name : 'El jugador ' + actor.name + ' canceló la reserva' } para el ${ moment(date).format('dddd, DD [de] MMM, HH:mm') }hs en la cancha ${ court.name }`,
            isToast: true,
            isDesktop: true
        },
        'done': {
            title: 'Reserva cobrada',
            type: 'success',
            message_simple: ({actor, date, court, booking}) => `Se cobró la reserva ${ booking.online ? 'online': '' } de las ${ moment(date).format('HH:mm') }hs en ${ court.name }.`,
            message_full: ({actor, date, court, booking}) => `La reserva ${ booking.online ? 'online': '' } de las ${ moment(date).format('HH:mm') }hs en ${ court.name } fue cobrada por ${ actor.name }`,
            isToast: true,
            isDesktop: true
        },
        'default': {
            title: '',
            type: 'info',
            message_simple: _.template('')
        }
    };

    return Factory;
}

export default NotificationFactory;